<template>
    <div class='text-left' v-resize="onResize">
        <div class="bodyPage">
            <v-row>
                <v-col
                    xs="12" sm="12" md="4" lg="4" xl="4"
                    class="colPadding"  
                >
                    <div class="cardHeader">
                        <span class="title">{{'Dados da Empresa' | translate('Empresa')}}</span>
                        <span class="subtitle">{{'Para começar, cadastre a sua empresa.' | translate('Empresa')}}</span>
                    </div>
                    <v-row class="rowPadding">
                        <v-col>
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.CNPJ"
                                :label="labels.cnpj"
                                v-mask="masks.cnpj"
                                :rules="[rules.cnpj]"
                                counter="18"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="rowPadding">
                        <v-col>
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.RAZAO_SOCIAL"
                                :label="labels.razao"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="rowPadding">
                        <v-col>
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.FANTASIA"
                                :label="labels.fantasia"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider class="horisontalDivider"></v-divider>
                    <div class="cardHeader">
                        <span class="title">{{'Logo da Empresa' | translate('Empresa')}}</span>
                        <span class="subtitle">{{'Selecione o logo da empresa, este será exibido em determinadas partes do sistema.' | translate('Empresa')}}</span>
                    </div>
                    <v-row>
                        <v-col class="fileColumn">
                            <label for="assetsFieldHandle" class="dragAndDropFile" @drop="onFileChange" @dragover="dragover" @dragleave="dragleave">
                                <input id="assetsFieldHandle" class="inputFile" type="file" @change="onFileChange" ref="file" accept=".pdf,.jpg,.jpeg,.png">
                                <div id="loadingImg" class="boxItems vs-con-loading__container">
                                    <img v-if="loading" :src="file_upload" width="140" />
                                    <img v-else :src="getImage()" width="140" alt="a cool image"/>
                                    <span>
                                        {{'Clique, ou arraste seu arquivo aqui' | translate('Empresa')}} 
                                    </span>
                                </div>
                            </label>
                        </v-col>
                    </v-row>
                </v-col>
                <v-divider v-resize="onResize" class="verticalDivider" vertical></v-divider>
                <v-col
                    xs="12" sm="12" md="7" lg="7" xl="7"
                    class="colPadding"    
                >
                    <div class="cardHeader">
                        <span class="title">{{'Dados Complementares' | translate('Empresa')}}</span>
                        <span class="subtitle">{{'Informe os dados referentes ao endereço da empresa.' | translate('Empresa')}}</span>
                    </div>
                    <v-row class="rowPadding">
                        <v-col cols="6">
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.PAIS"
                                :label="labels.pais"
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.ESTADO"
                                :label="labels.estado"
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="rowPadding">
                        <v-col cols="4">
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.CEP"
                                :label="labels.cep"
                                v-mask="masks.cep"
                                :rules="[rules.required]"
                                required
                                counter="9"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.CIDADE"
                                :label="labels.cidade"
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.BAIRRO"
                                :label="labels.bairro"
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="rowPadding">
                        <v-col cols="6">
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.RUA"
                                :label="labels.rua"
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.NUMERO"
                                :label="labels.numero"
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="rowPadding">
                        <v-col cols="12">
                            <v-text-field
                                @input="validateSaveBtn"
                                :loading="loading"
                                v-model="editedItem.COMPLEMENTO"
                                :label="labels.complemento"
                                :rules="[rules.required]"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <div class="footer">
                        <v-btn
                            small
                            class="white--text btn1 floatBtn" 
                            color="black"
                            :disabled="disableButtonSave"
                            @click="save()"
                        >{{'Salvar' | translate('Empresa')}}</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import translate from '../../../src/plugins/translate'
import loadCompany from '../../../src/app/empresa/loadCompany'
import updateCompany from '../../../src/app/empresa/updateCompany'
import addCompany from '../../../src/app/empresa/addCompany'
import uploadFile from '../../../src/app/file/upload'
import { createNamespacedHelpers } from 'vuex'

const user = createNamespacedHelpers('user')

export default {
    name: 'Empresa',
    data() {
        return {
            disableButtonSave: true,
            loading: false,
            editedItem: {CNPJ: null, CEP:null, IMAGEM_PERFIL: null},
            imageTime: new Date().getTime(),
            masks: {
                cnpj: null,
                cep: null
            },
            labels: {
                cnpj: 'CNPJ',
                razao: translate('Razão Social', 'Empresa'),
                fantasia: translate('Fantasia', 'Empresa'),
                pais: translate('Pais', 'Empresa'),
                estado: translate('Estado', 'Empresa'),
                cep: 'CEP',
                cidade: translate('Cidade', 'Empresa'),
                bairro: translate('Bairro', 'Empresa'),
                rua: translate('Rua', 'Empresa'),
                numero: translate('Número', 'Empresa'),
                complemento: translate('Complemento', 'Empresa')
            },
            rules: {
                required: (val) => !!val || translate('Deve ser preenchido!','Empresa'),
                cnpj: (val) => {
                    const patern = /[0-9]{14}/
                    if(!val) return translate('Deve ser preenchido!','Empresa')
                    val = val.replace(/[-.^/]/g, '')
                    return patern.test(val) || translate('CNPJ invalido!','Empresa')
                }
            },
            file_upload: require('../../../src/assets/system/file_upload.png'),
            baseUrl: process.env.VUE_APP_API_URL
        }
    },
    methods: {
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        },
        dragover(event) {
            event.preventDefault();
            event.currentTarget.style.backgroundColor="#ededed"
        },
        dragleave(event) {
            event.currentTarget.style.backgroundColor="transparent"
        },
        onFileChange(event) {
            event.preventDefault();
            var files = event.target.files || event.dataTransfer.files
            if (!files.length) return
            this.image = files[0]
            this.editedItem.IMAGEM_PERFIL = null
            this.criateShowImage(this.image)
            this.dragleave(event)
        },
        criateShowImage(file) {
            var reader = new FileReader()
            this.imageTime = new Date().getTime()
            var self = this
            self.$vs.loading({
                container: '#loadingImg',
                color: 'black',
                scale: 0.6
            })
            reader.onload = (event) => {
                setTimeout(() => {
                    self.editedItem.IMAGEM_PERFIL = event.target.result
                    self.$vs.loading.close('#loadingImg > .con-vs-loading')
                }, 100)
            }
            reader.readAsDataURL(file);
        },
        validateSaveBtn(){
            if(!this.editedItem.CNPJ || !this.editedItem.CNPJ.length) return this.disableButtonSave = true
            if(!this.editedItem.RAZAO_SOCIAL || !this.editedItem.RAZAO_SOCIAL.length) return this.disableButtonSave = true
            if(!this.editedItem.FANTASIA || !this.editedItem.FANTASIA.length) return this.disableButtonSave = true
            if(!this.editedItem.PAIS || !this.editedItem.PAIS.length) return this.disableButtonSave = true
            if(!this.editedItem.ESTADO || !this.editedItem.ESTADO.length) return this.disableButtonSave = true
            if(!this.editedItem.CEP || !this.editedItem.CEP.length) return this.disableButtonSave = true
            if(!this.editedItem.CIDADE || !this.editedItem.CIDADE.length) return this.disableButtonSave = true
            if(!this.editedItem.BAIRRO || !this.editedItem.BAIRRO.length) return this.disableButtonSave = true
            if(!this.editedItem.RUA || !this.editedItem.RUA.length) return this.disableButtonSave = true
            if(!this.editedItem.NUMERO || !this.editedItem.NUMERO.length) return this.disableButtonSave = true
            if(!this.editedItem.COMPLEMENTO || !this.editedItem.COMPLEMENTO.length) return this.disableButtonSave = true
            return this.disableButtonSave = false
        },
        async getCompany() {
            this.resetVariables()
            this.loading = true
            await loadCompany(this.user.EMPRESA_ID)
                .then(function(response){
                    this.$nextTick(() => {
                        this.editedItem = {CNPJ: null, CEP:null, IMAGEM_PERFIL: null}
                        this.editedItem = Object.assign({}, response.data)
                        this.loading = false
                    })
                }.bind(this))
                .catch(function(){
                    this.loading = false
                }.bind(this))
            this.refreshMasks() 
        },
        async save() {
            this.loading = true
            if(this.editedItem.CEP) this.editedItem.CEP = this.editedItem.CEP.replace(/[-.]/g, '')
            if(this.editedItem.CNPJ) this.editedItem.CNPJ = this.editedItem.CNPJ.replace(/[-.^/]/g, '')
            await this.editedItem.PESSOA_ID ? updateCompany(this.editedItem).then(this.uploadImage) : addCompany(this.editedItem).then(this.uploadImage)
        },
        async uploadImage(response) {
            this.$nextTick(() => {
                this.editedItem.IMAGEM_PERFIL = null
            })
            var self = this  
            if(this.image){
                var formData = new FormData()
                formData.append('image', self.image, self.image.name)
                await uploadFile({directory:'img/empresas', personId:response.data.PESSOA_ID}, formData)
                    .then(function(){
                        self.image = null
                        self.loading = false
                    }.bind(self))
                    .catch(function(){
                        self.loading = false
                    }.bind(self))
            } else {
                this.loading = false
            }
            await this.getCompany()
        },
        resetVariables () {
            this.image = null
            this.editedItem = {CNPJ: null, CEP:null, IMAGEM_PERFIL: null}
            this.masks.cnpj = null
            this.masks.cep = null
        },
        refreshMasks() {
            this.$nextTick(() => {
                this.masks.cnpj = '##.###.###/####-##'
                this.masks.cep = '#####-###'
            })
        },
        getImage() {
            if(this.editedItem.IMAGEM_PERFIL){
                return this.editedItem.IMAGEM_PERFIL.includes('base64') ? this.editedItem.IMAGEM_PERFIL : this.baseUrl + this.editedItem.IMAGEM_PERFIL + '?t=' + this.imageTime
            }
            else return this.file_upload
        }
    },
    computed:{
        ...user.mapGetters(['user'])
    },
    async mounted() {
        this.onResize()
        this.loading = true
        await this.getCompany()
    },

}
</script>
<style scoped>
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.bodyPage{
    margin-top:1em;
    padding:2em;
}
.verticalDivider{
    margin: 4em 2em;
}
.horisontalDivider{
    margin: 3em;
}
.colPadding{
    padding: 0 1em;
}
.cardHeader{
    display: grid;
    margin-bottom: 1em;
}
.title{
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 1em;
}
.fileColumn{
    padding: 2em;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dragAndDropFile{
    border: 2px solid #afafaf;
    border-radius: 20px;
    min-height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-style: dashed;
}
.dragAndDropFile:hover{
    cursor: pointer !important;
    background-color: #ededed;
}
.boxItems{
    padding: 1em;
    display: grid;
    justify-items: center;
}
.inputFile{
    overflow: hidden;
    display: none;
}
.rowPadding{
    padding: 0 1em;
}
.rowPadding > .col{
    padding: 0px 10px;
}
.footer{
    position: relative;
    height: 16em;
}
.btn1{
    text-transform: none;
}
.floatBtn{
    position: absolute;
    right: 0;
    bottom: 0;
}
@media only screen and (max-width: 539px){
    .verticalDivider{
        display: none;
    }
    .footer{
        height: 4em;
    }
}
@media only screen and (min-width: 540px) and (max-width: 737px){
    .footer{
        height: 4em;
    }
}
</style> 